import get from 'lodash/get';

const getDomainFromEmail = (email) => {
  if (!email) return '';
  return get(email.split('@'), '[1]', '');
};

export default getDomainFromEmail;
